// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Doctor Who Universe - Main Export
 */

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { DoctorWhoAliensPlanets } from './AliensConfig';

export const universeDoctorWho = {
  id: 'doctorwho',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: DoctorWhoAliensPlanets
};

export default universeDoctorWho;
